import React, {Component} from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../helper/APIUtils";
import Alert from "react-s-alert";
import {showAxiosError} from "../../helper/helper";
import Select from"../../local_node_modules/react-select"
import {filterOptions} from "../../helper/invoiceHelper";

class Tagging extends Component {
    constructor(props) {
        super(props);
        this.state = {

            customizerModal:true,
            isAll: false,
            value: null,
            tag: null,
            disableTagging:false

        };

        this.closeCustomizerModal = this.closeCustomizerModal.bind(this);
        this.tagging = this.tagging.bind(this);
        this.getTag = this.getTag.bind(this);
        this.arrowRenderer = this.arrowRenderer.bind(this);
        this.onTagChange = this.onTagChange.bind(this);
        this.addNewTag = this.addNewTag.bind(this);
        this.removeTag = this.removeTag.bind(this);
    }

    closeCustomizerModal() {

        this.setState({customizerModal: false});
        this.props.closeClick();

    }

    arrowRenderer(e) {
        let onMouseDown = e.onMouseDown;
        return React.createElement('span', {
            className: 'search',
            onMouseDown: onMouseDown
        });
    }

    getTag(key) {
        if (!key) {
            return Promise.resolve({options: []});
        } else {
            if (key.length >= 1) {
                let type = this.props.tagType;
                let params = {
                    url: `/tag/searchTag?key=` + key + '&type=' + type,
                    method: "get",
                };
                return request(params)
                    .then(response => {
                        let tagList = response.data;
                        let options = tagList.map(tag => ({
                            value: tag.tagName,
                            label: tag.tagName,
                            tag: tag
                        }));
                        return {options};
                    })
                    .catch(function (error) {
                        showAxiosError(error);
                    });
            } else {
                return Promise.resolve({options: []});
            }
        }
    }

    addNewTag(option ) {
        let self = this;
        let  type =  self.props.tagType;
        let tagName = option.value;
        let params = {
            url: 'tag/save',
            method: 'post',
            data:{tagName,type},
        };
        request(params)
            .then(function (response) {
                Alert.success("İşaret başarılı bir şekilde eklendi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 1500,
                    html:false
                });
                self.setState({value:tagName,tag:response.data});
                self.setState({rowId:null});
            }).catch(function (error) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                self.setState({loading: false,searching: false});
                // self.props.reload(false);
                showAxiosError(error);
            });

    }

    removeTag() {
        let self = this;
        let invoiceList = this.props.invoiceList;
        let filteredInvoiceList=[];
        let type = self.props.tagType;
        let year = this.props.year;
        let month = this.props.month;
        let tag=this.state.tag;
        let operation="remove";
        if(invoiceList.length> 0 && this.state.tag != null ) {
            let params = {
                url: '/' + this.props.controllerName +'/tagging' ,
                method: 'post',
                data:{year,month,invoiceList,tag,operation}
            };
            request(params)
                .then(function (response) {
                    Alert.success("Faturaların işaretleri  başarılı bir şekilde kaldırıldı.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 1500,
                        html:false
                    });
                    self.setState({value:null , tag:null});
                    self.setState({rowId:null});
                    self.props.closeClick();
                }).catch(function (error) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                self.setState({loading: false,searching: false});
                showAxiosError(error);
                self.props.closeClick();
            });}
        else{
            showAxiosError({message: "Lütfen faturaları ve işareti seçtiğinizden emin olunuz."});
        }
    }

    tagging() {
        let self = this;
        let invoiceList = this.props.invoiceList;
        let type = self.props.tagType;
        let year=this.props.year;
        let month = this.props.month;
        let tag=this.state.tag;
        let operation="add";
        let tagList=[];
        self.setState({disableTagging:true});
        if(invoiceList.length> 0 && this.state.tag != null )
        {
            let params = {
                url: '/' + this.props.controllerName + '/tagging' ,
                method: 'post',
                data:{year,month,invoiceList,tag,operation}
            };
            request(params)
                .then(function (response) {
                    Alert.success("Faturalar  başarılı bir şekilde işaretlendi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 1500,
                        html:false
                    });
                    self.setState({value:null , tag:null , disableTagging:false , invoiceList:null});
                    self.setState({rowId:null,disableTagging:false});
                    self.props.closeClick();
                }).catch(function (error) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                self.setState({loading: false,searching: false,disableTagging:false,invoiceList:null});
                showAxiosError(error);
                self.props.closeClick();
            });}
        else{
            showAxiosError({message: "Lütfen faturaları ve işareti seçtiğinizden emin olunuz."});
            self.setState({disableTagging:false});
        }
    }

    onTagChange(data) {
        this.setState({value:data.tag.tagName})
        this.setState({tag:data.tag});

    }

    render()
    {
        return (
            <div>
                <Modal isOpen={this.state.customizerModal} size={'lg'}>
                    <ModalHeader toggle={this.closeCustomizerModal}> İşaretle</ModalHeader>
                    <ModalBody>
                        <div className="row col-sm-12" style={{marginBlockEnd:"15px"}}>
                            <label className="col-sm-3 col-form-label" style={{fontSize:"15px",marginLeft:"5px"}}>İşaret Adı:</label>
                            <div className="col-sm-4">
                                <Select.AsyncCreatable

                                    multi={false}
                                    ignoreAccents={false}
                                    value={{
                                        value: this.state.value,
                                        label: this.state.value
                                    }}
                                    onChange={(e) => e && this.onTagChange(e)}
                                    isLoading={true}
                                    autoload={false}
                                    cache={false}
                                    clearable={true}
                                    noResultsText="Kayıt bulunamadı."
                                    searchPromptText="Arama için en az 1 karakter giriniz."
                                    placeholder="Ürün Adı ile arama yapabilirsiniz"
                                    loadingPlaceholder="Yükleniyor..."
                                    onNewOptionClick={(option) => this.addNewTag(option)}
                                    filterOptions={(options, filter, currentValues)=> filterOptions(options, filter, currentValues)}
                                    promptTextCreator={(label) => "İşareti Ekle"}
                                    showNewOptionAtTop={false}
                                    arrowRenderer={this.arrowRenderer}
                                    onCloseResetsInput={false}
                                    loadOptions={(key)=>this.getTag(key)}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12" >
                            <div className="col-sm-3 left">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background:' linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))', padding:'9px 45px 9px 20px'}}
                                        rel="tooltip" className="  TekBtn kaldir btn-icon sag-1 pull-right"
                                        onClick={(e) => this.removeTag()}>
                                    İşareti Kaldır
                                </button>
                            </div>
                            <div className="col-sm-3 right">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            marginRight: '10px',
                                            marginLeft: '15px'
                                        }}
                                        disabled={this.state.disableTagging}
                                        rel="tooltip" className="  TekBtn ekle btn-icon sag-1 pull-right"
                                        onClick={() => this.tagging()}>
                                    İşaretle
                                </button>
                            </div>
                        </div>
                    </ModalBody>

                </Modal>
            </div>
        );
    };
}



export default Tagging;